// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  min-width: 930px;
}
:host .mat-table {
  overflow: auto;
  /* min-width: 1500px; */
  height: 100%;
}
:host .mat-header-cell.mat-sort-header-sorted {
  /* color: black; */
}
:host .mat-row {
  min-height: 34px;
  height: 34px;
  border-bottom-color: rgba(0, 0, 0, 0.06);
}
:host .mat-cell {
  font-size: 13px;
}
:host .mat-cell ::ng-deep .mat-checkbox-inner-container {
  height: 16px;
  width: 16px;
  margin-left: 2px;
}
:host .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
  /* background-color: rgba(0,0,0,0.7); */
  /* background-color: rgb(30, 30, 30); */
  /* color: white; */
}
:host .mat-header-cell {
  /* color: white; */
  font-size: 11px;
}
:host .mat-column-toogle {
  overflow: visible;
  flex: 0 0 40px;
}
:host .mat-column-name {
  flex: 0 0 220px;
}
:host .mat-column-address {
  flex: 0 0 380px;
}
:host .mat-column-device {
  flex: 0 0 220px;
}
:host .mat-column-select {
  flex: 0 0 40px;
}
:host .my-header-filter ::ng-deep .mat-sort-header-content {
  display: unset;
  text-align: left;
}
:host .my-header-filter ::ng-deep .mat-sort-header-button {
  display: block;
  text-align: left;
  margin-top: 5px;
}
:host .my-header-filter span {
  padding-left: 5px;
}
:host .my-header-filter ::ng-deep .mat-sort-header-arrow {
  /* color: white; */
  top: -14px;
  right: 20px;
}
:host .my-header-filter-input {
  display: block;
  margin-top: 4px;
  margin-bottom: 6px;
  /* color: white; */
  padding: 3px 1px 3px 2px;
  border-radius: 2px;
  border: 1px solid var(--formInputBackground);
  background-color: var(--formInputBackground);
  color: var(--formInputColor);
}
:host .my-header-filter-input:focus {
  padding: 3px 1px 3px 2px;
  border: 1px solid var(--formInputBorderFocus);
  background-color: var(--formInputBackgroundFocus);
}`, "",{"version":3,"sources":["webpack://./src/app/device/device-tag-selection/device-tag-selection.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/device-tag-selection/device-tag-selection.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;ACAR;ADGI;EACI,cAAA;EACA,uBAAA;EACA,YAAA;ACDR;ADII;EACI,kBAAA;ACFR;ADKI;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;ACHR;ADMI;EACI,eAAA;ACJR;ADOI;EACI,YAAA;EACA,WAAA;EACA,gBAAA;ACLR;ADQI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;EACA,uCAAA;EACA,uCAAA;EACA,kBAAA;ACNR;ADQI;EACI,kBAAA;EACA,eAAA;ACNR;ADSI;EACI,iBAAA;EACA,cAAA;ACPR;ADUI;EACI,eAAA;ACRR;ADWI;EACI,eAAA;ACTR;ADYI;EACI,eAAA;ACVR;ADaI;EACI,cAAA;ACXR;ADcI;EACI,cAAA;EACA,gBAAA;ACZR;ADeI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;ACbR;ADgBI;EACI,iBAAA;ACdR;ADkBI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AChBR;ADmBI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,4CAAA;EACA,4CAAA;EACA,4BAAA;ACjBR;ADoBI;EACI,wBAAA;EACA,6CAAA;EACA,iDAAA;AClBR","sourcesContent":[":host {\n    .container {\n        min-width: 930px;\n    }\n\n    .mat-table {\n        overflow: auto;\n        /* min-width: 1500px; */\n        height: 100%;\n    }\n      \n    .mat-header-cell.mat-sort-header-sorted {\n        /* color: black; */\n    }\n    \n    .mat-row {\n        min-height: 34px;\n        height: 34px;\n        border-bottom-color: rgba(0,0,0,0.06);\n    }\n    \n    .mat-cell {\n        font-size: 13px;\n    }\n    \n    .mat-cell ::ng-deep .mat-checkbox-inner-container {\n        height: 16px;\n        width: 16px;\n        margin-left: 2px;\n    }\n    \n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n        /* background-color: rgba(0,0,0,0.7); */\n        /* background-color: rgb(30, 30, 30); */\n        /* color: white; */\n    }\n    .mat-header-cell {\n        /* color: white; */\n        font-size: 11px;\n    }\n    \n    .mat-column-toogle {\n        overflow: visible;\n        flex: 0 0 40px;\n    }\n    \n    .mat-column-name {\n        flex: 0 0 220px;\n    }\n    \n    .mat-column-address {\n        flex: 0 0 380px;\n    }\n    \n    .mat-column-device {\n        flex: 0 0 220px;\n    }\n    \n    .mat-column-select {\n        flex: 0 0 40px;\n    }\n    \n    .my-header-filter ::ng-deep .mat-sort-header-content {\n        display: unset;\n        text-align: left;\n    }\n    \n    .my-header-filter ::ng-deep .mat-sort-header-button {\n        display: block;\n        text-align: left;\n        margin-top: 5px;\n    }\n    \n    .my-header-filter span {\n        padding-left: 5px;\n    \n    }\n    \n    .my-header-filter ::ng-deep .mat-sort-header-arrow {\n        /* color: white; */\n        top: -14px;\n        right: 20px;\n    }\n    \n    .my-header-filter-input {\n        display: block; \n        margin-top: 4px;\n        margin-bottom: 6px;\n        /* color: white; */\n        padding: 3px 1px 3px 2px;\n        border-radius: 2px;\n        border: 1px solid var(--formInputBackground);\n        background-color: var(--formInputBackground);\n        color: var(--formInputColor);\n    }\n    \n    .my-header-filter-input:focus {\n        padding: 3px 1px 3px 2px;\n        border: 1px solid var(--formInputBorderFocus);\n        background-color: var(--formInputBackgroundFocus);\n    }\n}\n",":host .container {\n  min-width: 930px;\n}\n:host .mat-table {\n  overflow: auto;\n  /* min-width: 1500px; */\n  height: 100%;\n}\n:host .mat-header-cell.mat-sort-header-sorted {\n  /* color: black; */\n}\n:host .mat-row {\n  min-height: 34px;\n  height: 34px;\n  border-bottom-color: rgba(0, 0, 0, 0.06);\n}\n:host .mat-cell {\n  font-size: 13px;\n}\n:host .mat-cell ::ng-deep .mat-checkbox-inner-container {\n  height: 16px;\n  width: 16px;\n  margin-left: 2px;\n}\n:host .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n  /* background-color: rgba(0,0,0,0.7); */\n  /* background-color: rgb(30, 30, 30); */\n  /* color: white; */\n}\n:host .mat-header-cell {\n  /* color: white; */\n  font-size: 11px;\n}\n:host .mat-column-toogle {\n  overflow: visible;\n  flex: 0 0 40px;\n}\n:host .mat-column-name {\n  flex: 0 0 220px;\n}\n:host .mat-column-address {\n  flex: 0 0 380px;\n}\n:host .mat-column-device {\n  flex: 0 0 220px;\n}\n:host .mat-column-select {\n  flex: 0 0 40px;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-content {\n  display: unset;\n  text-align: left;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-button {\n  display: block;\n  text-align: left;\n  margin-top: 5px;\n}\n:host .my-header-filter span {\n  padding-left: 5px;\n}\n:host .my-header-filter ::ng-deep .mat-sort-header-arrow {\n  /* color: white; */\n  top: -14px;\n  right: 20px;\n}\n:host .my-header-filter-input {\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 6px;\n  /* color: white; */\n  padding: 3px 1px 3px 2px;\n  border-radius: 2px;\n  border: 1px solid var(--formInputBackground);\n  background-color: var(--formInputBackground);\n  color: var(--formInputColor);\n}\n:host .my-header-filter-input:focus {\n  padding: 3px 1px 3px 2px;\n  border: 1px solid var(--formInputBorderFocus);\n  background-color: var(--formInputBackgroundFocus);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
